import { useEffect, useRef, useState } from 'react';

import { SORT } from '@/components/list-bar/ListBarProfile';
import type { AssetData } from '@/contents/user-profile/content/artwork/useUserArwork';
import { getAssetByCollectionId } from '@/services';

const PAGE_SIZE = 12;

const useAssetCollection = (collectionId: number) => {
  const assetDataRef = useRef([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [assetData, setAssetData] = useState<AssetData[]>([]);
  const [loading, setLoading] = useState(false);
  const [sort, setSort] = useState(SORT.desc);
  const [search, setSearch] = useState('');

  const getListAsset = async (page: number) => {
    const offset = PAGE_SIZE * (page - 1);
    const sortAsset = encodeURIComponent(`{"createdAt":"${sort}"}`);
    const filter = { name: search };

    setLoading(true);
    const res = await getAssetByCollectionId({
      collectionId,
      pageSize: PAGE_SIZE,
      offset,
      sort: sortAsset,
      filter,
    });

    if (page === 1) {
      assetDataRef.current = [];
      setAssetData([]);
    }

    assetDataRef.current = assetDataRef.current.concat(res?.data?.items);
    const checkDuplicate: any = Array.from(
      new Set(assetDataRef.current.map((asset: any) => asset.id)),
    ).map((id) => {
      return assetDataRef.current.find((asset: any) => asset.id === id);
    });
    setAssetData(checkDuplicate);
    setLoading(false);
  };

  const loadMore = (page: number) => {
    setCurrentPage(page);
    getListAsset(page);
  };

  useEffect(() => {
    getListAsset(1);
  }, [sort, search]);

  return {
    assetData,
    loading,
    currentPage,
    setCurrentPage,
    setSearch,
    setSort,
    loadMore,
    assetDataRef,
    setAssetData,
  };
};

export default useAssetCollection;
